<template>
  <div>
    <v-simple-table dense>
      <tbody>
        <tr>
          <td>
            Total Investment
          </td>
          <td>Total Revenue</td>
          <td>Total Profit</td>
          <!-- <td>Gross Margin</td> -->
          <td>Profit Percentage</td>
        </tr>
        <tr>
          <td><dollar-sign />{{ report.profit_summary.total_investment | toFixed(2) | addCommas }}</td>
          <td><dollar-sign />{{ report.profit_summary.total_revenue | toFixed(2) | addCommas }}</td>
          <td><dollar-sign />{{ report.profit_summary.total_profit | toFixed(2) | addCommas }}</td>
          <td>{{ report.profit_summary.profit_percent | decimalToPercent(2) }}</td>
        </tr>
        <tr>
          <td>Average Cost Per Cat</td>
          <td>Average Return Per Cat</td>
          <td>Average Profit Per Cat</td>
          <td>Internal Proforma Gross</td>
        </tr>
        <tr>
          <td><dollar-sign />{{ report.profit_summary.avg_cost_per_cat | toFixed(2) | addCommas }}</td>
          <td><dollar-sign />{{ report.profit_summary.avg_return_per_cat | toFixed(2) | addCommas }}</td>
          <td><dollar-sign />{{ report.profit_summary.avg_profit_per_cat | toFixed(2) | addCommas }}</td>
          <td><dollar-sign />{{ report.profit_summary.internal_proforma_value | toFixed(2) | addCommas }}</td>
        </tr>
        <tr>
          <td>Average Cost Per Pound</td>
          <td>Average Return Per Pound</td>
          <td>Average Profit Per Pound</td>
          <td>Hedge Adjusted Profit</td>
        </tr>
        <tr>
          <td><dollar-sign />{{ report.profit_summary.avg_cost_per_lb | toFixed(2) | addCommas }}</td>
          <td><dollar-sign />{{ report.profit_summary.avg_return_per_lb | toFixed(2) | addCommas }}</td>
          <td><dollar-sign />{{ report.profit_summary.avg_profit_per_lb | toFixed(2) | addCommas }}</td>
          <td><dollar-sign />{{ report.profit_summary.hedge_desk_profit | toFixed(2) | addCommas }}</td>
        </tr>
        <tr>
          <td />
          <td />
          <td />
          <td>HAP %</td>
        </tr>
        <tr>
          <td />
          <td />
          <td />
          <td>{{ report.profit_summary.profit_inc_hdp_percent | toFixed(2) | addCommas }}%</td>
        </tr>
      </tbody>
    </v-simple-table>
  </div>
</template>

<script>

export default {
  name: 'FinalReportProfit',
  props: {
    report: {
      type: Object,
      required: true
    }
  }
}
</script>
